module.exports = __webpack_public_path__ + "img/TD.f6b0a98f.svg";